import { CloudCode } from './cloudcode';
import { SelectedServiceType } from "../models/selected-service-type-list";
import { Address } from '../models/address';
import { Popup } from '../models/popup';

// Request interface
export interface MainScreenContentParams {
  businessID?: string;
  proType: string;
  timezoneOffset: number;
  // startTime?: Date;
  weekNumber: number;
  serviceTypeList: SelectedServiceType[];
  address: Address;
  device?: string;
  showContentWhenUnavailable: boolean;
  skipCache?: boolean;
  shouldShowConciergeChat: boolean;
  shouldShowURLBanner: boolean;
  includePopups: boolean;
  includeOutOfRadiusAvails: boolean;
  includeOtherServiceCategories: boolean;
}

interface MainScreenContentRsp {
  content: any[]
  popups: Popup[]
}

export class MainScreenContent {

  static load(
    params: MainScreenContentParams,
    successCallback: (content: any[], popups: Popup[]) => void,
    errorCallback: (msg: string) => void) {

    params.device = "android"

    CloudCode.run('pullMainScreenContent', 
      params, 
      (rsp: MainScreenContentRsp) => {
        successCallback(rsp.content, rsp.popups);
      }, 
      (msg: string) => {
        errorCallback(msg);
      });
  }

  static loadBusiness(
    successCallback: (rsp: any[]) => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('pullMainScreenContent_Business', 
      {}, 
      (rsp: any[]) => {
        successCallback(rsp);
      }, 
      (msg: string) => {
        errorCallback(msg);
      });
  }

}
